module.exports = __webpack_public_path__ + "static/collaborationfig-ccaf246cc6054886b61b1d19258ff8ec.png";